export default "__VITE_ASSET__sKvqWnR4__"